import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components';

export const contentWrapper = css`
  display: flex;
  height: 100%;
`;

export const leftSideWrapper = css`
  padding: 25px 30px;
  width: 548px;
`;

export const rightSideWrapper = css`
  background: rgba(244, 247, 249, 0.5);
  width: 352px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const headerMargin = css`
  margin-bottom: 10px;

  > :first-child {
    margin-bottom: 10px;
  }
`;

export const headerIconLine = css`
  display: flex;
  gap: 5px;

  > svg {
    color: ${colors.primary.default};
    width: ${icons.size.small};
    height: ${icons.size.small};
  }
`;

export const dateSelectionSection = css`
  margin-top: 25px;
`;

export const datePicker = css`
  margin-top: 10px;
  max-width: 140px;

  .noActivity {
    background: ${colors.gray.lightest} !important;
    color: ${colors.custom.gray50};
    pointer-events: none;

    :where([aria-disabled="true" i], [disabled]) {
      cursor: default;
      background-color: unset !important;
    }
  }

  .outOfRange {
    color: ${colors.custom.gray50};
    pointer-events: none;
  }

  .recent {
    position: relative;

    :before {
      content: "";
      border-radius: 100%;
      background: ${colors.primary.default};
      height: 6px;
      width: 6px;
      position: absolute;
      bottom: 2px;
    }

    :where([aria-disabled="true" i], [disabled]) {
      cursor: default;

      ::before {
        content: unset;
      }
    }
  }

  div.current.recent {
    :before {
      background: ${colors.primary.disabled};
    }
  }

  .toBeExpired {
    position: relative;

    :before {
      content: "";
      border-radius: 100%;
      background: ${colors.accessory._3};
      height: 6px;
      width: 6px;
      position: absolute;
      bottom: 2px;
    }

    :where([aria-disabled="true" i], [disabled]) {
      cursor: default;

      ::before {
        content: unset;
      }
    }
  }

  .expired {
    position: relative;
    color: ${colors.custom.gray50};
    pointer-events: none;

    :before {
      content: "";
      border-radius: 100%;
      background: ${colors.gray.default};
      height: 6px;
      width: 6px;
      position: absolute;
      bottom: 2px;
    }

    :where([aria-disabled="true" i], [disabled]) {
      cursor: default;

      ::before {
        content: unset;
      }
    }
  }
`;

export const calendarFootnotes = css`
  > hr {
    width: 264px;
    margin: 10px 0 15px -20px;
  }
`;

export const calendarFootnotesColors = css`
  > :nth-child(1) {
    margin-bottom: 10px;
  }

  > :nth-child(2) {
    margin-bottom: 4px;
    display: flex;
    gap: 5px;
    align-items: center;

    > div {
      width: 15px;
      height: 15px;
      background: ${colors.gray.light};
      border-radius: 2px;
    }
  }

  > :nth-child(3) {
    margin-bottom: 4px;
    display: flex;
    gap: 5px;
    align-items: center;

    > div {
      width: 15px;
      height: 15px;
      background: ${colors.primary.default};
      border-radius: 100%;
    }
  }

  > :nth-child(4) {
    margin-bottom: 4px;
    display: flex;
    gap: 5px;
    align-items: center;

    > div {
      width: 15px;
      height: 15px;
      background: ${colors.accessory._3};
      border-radius: 100%;
    }
  }

  > :nth-child(5) {
    margin-bottom: 4px;
    display: flex;
    gap: 5px;
    align-items: center;

    > div {
      width: 15px;
      height: 15px;
      background: ${colors.gray.default};
      border-radius: 100%;
    }
  }
`;

export const disabledOption = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > div {
    width: 6px;
    height: 6px;
    background: ${colors.gray.default};
    border-radius: 100%;
    margin-right: 6px;
  }
`;

export const periodAndHourDiv = css`
  margin-top: 35px;
  display: flex;
  gap: 115px;
`;

export const periodSelectDiv = css`
  & > *:last-child {
    min-width: 255px;
    margin-top: 10px;
    width: max-content;

    & > *:nth-child(3) {
      max-height: 210px;

      > div {
        max-height: 200px;

        > div {
          width: 100%;

          > div {
            width: 100%;
          }
        }
      }
    }
  }
`;

export const timePickerWrapper = css`
  display: flex;
  flex-direction: column;
`;

export const timePicker = css`
  width: 80px;
  margin-top: 10px;

  & > * {
    text-align: center;
  }
`;

export const inputErrorLabel = css`
  color: ${colors.error.default};
  margin-top: 5px;
`;
